// src/components/Bell.tsx
import React, { useMemo } from "react";
import { useOutletRenderer } from "../hooks/internal/useOutletRenderer.js";
import { Mounter } from "./Mounter.js";
import { jsx } from "react/jsx-runtime";
var Bell = React.memo((props) => {
  const renderBell = useOutletRenderer(props.renderBell);
  const mountProps = useMemo(() => renderBell ? { renderBell } : void 0, [renderBell]);
  return /* @__PURE__ */ jsx(Mounter, { name: "Bell", props: mountProps });
});
Bell.displayName = "Bell";
export {
  Bell
};
//# sourceMappingURL=Bell.js.map